import { render } from "./ObrasMainChart.vue?vue&type=template&id=16289eac&scoped=true"
import script from "./ObrasMainChart.vue?vue&type=script&lang=js"
export * from "./ObrasMainChart.vue?vue&type=script&lang=js"

import "./ObrasMainChart.vue?vue&type=style&index=0&id=16289eac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16289eac"]])

export default __exports__